import { install, gtag } from 'ga-gtag';

// googleKey: formInputName
const fieldMapping = {
  department: 'department',
  page_uri: 'page_uri',
  page_type: 'page_type',
  vehicle_group: 'group',
  vehicle_type: 'vehicle_type',
  vehicle_make: 'make',
  vehicle_model: 'model',
  vehicle_submodel: 'submodel',
  vehicle_year: 'year',
  vehicle_condition: 'condition',
  vehicle_location: 'gd_location',
  vehicle_stockid: 'stock_id',
  lead_entry_point: 'lead_entry_point',
  lead_id: 'lead_id',
};

export default class GaGtag {
  formData = null;

  constructor() {
    if (!window.Transwest?.ga4PropertyId) {
      console.warn(
        'Google Analytics 4 property ID is not set. GA tracking will not be initialized.',
      );
      return;
    }

    // Adds the global tag script to the head
    // Only needs to be called once, but can be safely called multiple times (script won't stack)
    install(window.Transwest.ga4PropertyId, {
      send_page_view: false,
    });

    this.queryString = '';
  }

  buildEventSubmission() {
    const submission = {};

    Object.entries(fieldMapping).forEach((entry) => {
      const [gaKey, formField] = entry;
      submission[gaKey] = this.getFormData(formField);
    });

    return submission;
  }

  submitEvent(formData, eventName = 'form_submit') {
    this.formData = formData;
    this.submission = this.buildEventSubmission();

    console.debug('Submission event attributes', this.submission);

    this.setQueryString();

    gtag('event', eventName, this.submission);
  }

  submitSuspectEvent(formData) {
    this.submitEvent(formData, 'spam_submission');
  }

  getFormData(key) {
    const data = this.formData.get(key);
    return !data || data === '' ? '(not set)' : data;
  }

  setQueryString() {
    const dimensionMapping = {
      department: 'department',
      page_uri: 'pageUri',
      page_type: 'pageType',
      vehicle_condition: 'condition',
      vehicle_location: 'location',
      vehicle_make: 'make',
      vehicle_model: 'model',
      vehicle_stockid: 'stockId',
      vehicle_submodel: 'submodel',
      vehicle_type: 'subcategory',
      vehicle_year: 'year',
      lead_entry_point: 'leadEntryPoint',
    };

    const params = new URLSearchParams();

    Object.entries(this.submission).forEach(([key, value]) => {
      const mappedGoogleDimensionKey = dimensionMapping[key];

      if (mappedGoogleDimensionKey && value !== '(not set)') {
        params.set(mappedGoogleDimensionKey, value);
      }
    });

    this.queryString = params.toString();
  }

  getQueryString() {
    console.debug(this.queryString);

    return this.queryString;
  }
}
